import Moment from 'moment-timezone';
import { BasicModel } from '@/models/BasicModel';

/**
 * Action object
 */
export class Action extends BasicModel {
  // Action-specific properties
  id = 0;

  name = '';

  comment = '';

  leader = 0;

  impact = 0;

  deadline = null;

  originalDeadline = null;

  pdca = 0;

  state = 0;

  plan = 0;

  gain = 0;

  gainUnit = '';

  archivedOn = null;

  completed = null;

  lastActionResolution = null;

  nPostpmt = 0;

  isSecuring = 0;

  isQuickAction = 0;

  created = null;

  endOfCreation = null;

  updated = null;

  actedOn = null;

  completedOn = null;

  // Foreign keys
  reportTeam = 0;

  affectTeam = 0;

  cause = 0;

  problem = 0;

  problemId = 0;

  gwStep = 0;

  // Built properties
  firstName = '';

  lastName = '';

  reportTeamName = '';

  problemTitle = '';

  causeText = '';

  lWhat = '';

  files = [];

  indicators = [];

  history = [];

  supportData = [];

  isSupport = 0;

  // Sorting properties
  archiveDateSortable = '';

  createdSortable = '';

  deadlineSortable = '';

  constructor(props, currentUser = null, autoFill = true) {
    super(props);
    this.setProps(props);
    if (autoFill) {
      this.created = this.created === null ? Moment().format('YYYY-MM-DD HH:mm:ss') : this.created;

      if (currentUser) {
        this.affectTeam = this.affectTeam === 0 ? currentUser.teamId : this.affectTeam;
        this.reportTeam = this.reportTeam === 0 ? currentUser.teamId : this.reportTeam;
      }
    }

    this.leader = this.leader === null ? 0 : this.leader;
    if (this.isSecuring) {
      this.isQuickAction = 1;
    }
  }

  setProps(props) {
    BasicModel.updateObjectProps(props, this);
  }

  /**
   * Return the params that should be used in the PUT /actions query to update an action.
   * @return {Object}
   */
  get updateQueryParams() {
    const noTransformParams = [
      'name',
      'comment',
      'gain',
      'gainUnit',
      'impact',
      'pdca',
      'state',
      'files',
      'indicators',
      'isSecuring',
      'isQuickAction',
      'problem',
      'cause',
    ];
    const params = noTransformParams.reduce((all, param) => ({ ...all, [param]: this[param] }), {});
    if (this.deadline !== null) {
      params.deadline = this.deadline;
    }
    if (this.endOfCreation !== null) {
      params.endOfCreation = this.endOfCreation;
    }
    if (this.leader > 0) {
      params.leader = this.leader;
    }
    return params;
  }
}

export default {
  Action,
};
